import React, { useState, useRef, useEffect } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  Grid,
  TextField,
  InputLabel,
  Stack,
  Card,
  CardContent,
  IconButton,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { ReactComponent as UploadFileIcon } from "../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import axios from "axios";
// import {ReactComponent as AddImage} from '../../../Icons/Add.svg'
import { width } from "@mui/system";
import PostAddIcon from "@mui/icons-material/PostAdd";
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Add, Remove } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import { removeData } from "../../../Redux/Feature/AdminSlice";
import axiosInstance from "../../../api/axiosInstance";

export default function AddCommonService({isEdit = false, serviceData = {}}) {
  const navigate = useNavigate();
  const allLanguages = useSelector((state) => state.language.languageList)
  const dispatch = useDispatch()

  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
    setValue
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      videoUrls: [{ url: "" }],
      images: [], 
    },
  });

  // Manage video URLs
const { fields: videoFields, append: addVideo, remove: removeVideo } = useFieldArray({
  control,
  name: "videoUrls",
});

// Manage images
const { fields: imageFields, append: addImage, remove: removeImage } = useFieldArray({
  control,
  name: "images",
});

  

  const Imgwatch = watch("img");

  const imgFile = useRef();

  console.log(imgFile)

  const imgFiles = useRef([]);

  useEffect(() => {
      if(isEdit && serviceData._id){
        setValue("title", serviceData.title)
        setValue("heading1", serviceData.heading1)
        setValue("description1", serviceData.description1)
        setValue("heading2", serviceData.heading2)
        setValue("description2", serviceData.description2)
        setValue("img", serviceData.img)
        setValue("videoUrls", serviceData.videoUrls)
        setValue("serviceAmount", serviceData.serviceAmount)
        setValue("images", serviceData.images)
        setValue("showButton", serviceData.showButton)
      }
  }, [isEdit, serviceData])


  const modules = {
    toolbar: [
      ["bold", "italic", "underline"], // toggled buttons
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"], // superscript/subscript
    ],
  };


  const headerDatas = {
    title : '',
    subtitle : ''
  }

  const [activeLanguagesHeader, setActiveLanguagesHeader] = useState(allLanguages);

  const [header, setHeader] = useState({
    en : { ...headerDatas }
  })


  const addHeaderLanguage = () => {
    const nextLanguage = allLanguages.find(lang => !activeLanguagesHeader.some(active => active.value === lang.value))
    if(nextLanguage){
      setActiveLanguagesHeader((prev) => [...prev, nextLanguage])
      setHeader((prev => ({...prev, [nextLanguage.value] : { ...headerDatas }})))
    }
}

const handleHeadingChange = (e, lang, key) => {
  setHeader((prev) => ({
    ...prev,
    [lang]: {
      ...(prev[lang] || { ...headerDatas }),
      [key]: e.target.value,
    },
  }));
};



const handleFileChange = (event, index) => {
  const file = event.target.files[0];
  if (file) {
    const newImages = [...watch("images")];
    newImages[index] = file;
    setValue("images", newImages);
  }
};

const onSubmit = async (data) => {
  console.log("Form Data:", data);

  const formData = new FormData();

  // Convert objects to JSON strings
  formData.append("title", JSON.stringify(data?.title));  
  formData.append("heading1", JSON.stringify(data?.heading1));  
  formData.append("description1", JSON.stringify(data?.description1));  
  formData.append("heading2", JSON.stringify(data?.heading2));  
  formData.append("description2", JSON.stringify(data?.description2));  
  formData.append("videoUrls", JSON.stringify(data?.videoUrls) || "");
  formData.append("serviceAmount", data?.serviceAmount || "");
  formData.append("showButton", data?.showButton || false);  
  
  if (data?.img) {
    formData.append("img", data.img);
  }

  if(!isEdit){
    if (data?.images?.length) {
      data.images.forEach((image, index) => {
        formData.append("images", image);
      });
    }
  }

  if(isEdit){
    const existingImages = data?.images?.filter(image => !(image instanceof File)) || [];
    formData.append("existingImages", JSON.stringify(existingImages));


    
    data.images.forEach((image) => {
      if (image instanceof File) {
        formData.append("images", image);
      }
    });    
  }
  
  


  if(isEdit){
    try {
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_API_URL}edit-common-service/${serviceData._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.status === 200) {
        navigate("/Admin/common-services");
      }
      console.log(response);
    } catch (error) {
      console.log(error);
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  }else{
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}add-common-service`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.status === 201) {
        toast.success(response?.data?.message)
        navigate("/Admin/common-services");
      }
      
      console.log(response);
    } catch (error) {
      console.log(error);
      toast.error(error?.message)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  }
  
};

console.log(Imgwatch)

  return (
    <>
    
    <Box sx={{ display : 'flex', justifyContent : 'flex-start', mt : 4, mb : 4, ml : '10%' }}>
    <ToastContainer />
      <ArrowBackIcon onClick={() => navigate('/Admin/common-services')}/>
    </Box>
    <Box sx={{ display: "flex", justifyContent: "center" }}>
    
      <Card sx={{ width: '80%', border:'1px solid #E5E7EB', borderRadius:"6px"}}>
        <CardContent style={{ padding: 0, margin: 0 }}>
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              borderRadius:'6px 6px 0px 0px'
              
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography variant="h6_1">Service Details</Typography>
          </Box> */}

          {/* <Divider /> */}
          <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              marginTop : 0,
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "black",
                }}>Service Details</Typography>
            </Box>
          <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  mt: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
               {errors?.heading2 ? 'Service Amount*' : 'Service Amount'}
              </InputLabel>
              <Controller
                 name={`serviceAmount`}
                rules={{ required: false }}
                control={control}
                render={({ field }) => (
                  <TextField
                    placeholder={`Service Amount`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.subtitle ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.subtitle) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.subtitle ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter subtitle</Typography> : null }
            </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              marginTop : 0,
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "black",
                }}>Banner Image</Typography>
            </Box>

              {Boolean(Imgwatch) ? (
                  <Box style={{ padding: "0px 17px 17px", mt : 2 }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  padding="23px"
                  borderRadius="8px"
                  sx={{ border: ".5px solid #1A2461", mt : 2 }}
                >
                  <Typography
                    variant="h9_1"
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    {isEdit ?
                    Imgwatch.filename ? 
                    <Box sx={{width : '150px', height : '90px'}} component='img' src={`${process.env.REACT_APP_FILE_PATH}${Imgwatch.filename}`}
                    />
                    : <ImgIcon />
                    : 
                    <Box component={'img'} sx={{width : '180px', height : '90px'}} src={URL.createObjectURL(Imgwatch)} />
                  }
                    {isEdit ? `${Imgwatch.originalname || Imgwatch?.name}` : Imgwatch?.name}
                  </Typography>
                  <ClearIcon
                    onClick={() => setValue("img", null)}
                    sx={{ color: "#1A2461" }}
                  />
                </Stack>
                </Box>
              ) : (
                <Box
                  xs={12}
                  onClick={() => imgFile.current.click()}
                  sx={{
                    border: Boolean(errors.img)
                      ? "1px dashed red"
                      : "1px dashed #1A2461",
                    height: "200px",
                    borderRadius: "8px",
                    backgroundColor: "#F9FBFF",
                    margin: '20px 17px 17px'
                  }}
                >
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    height="100%"
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        height: "100px",
                        width: "100px",
                        borderRadius: "100px",
                        backgroundColor: "#F2F2F2",
                      }}
                    >
                      <UploadFileIcon fill="#1A2461" />
                    </Stack>
                    <Stack mt={2} direction="row" alignItems="center" gap="5px">
                      <Typography variant="h9_1">Click to upload</Typography>
                    </Stack>
                    <Typography variant="h9_5">
                      Allowed formats - JPEG, PNG
                    </Typography>
                  </Stack>
                  <Box sx={{marginTop : '0.3rem'}}>
                      {errors?.img ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please select an Image</Typography> : null}
                    </Box>
                </Box>
              )}
              <Controller
                name="img"
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      field.onChange(e.target.files[0]);
                      e.target.value = null;
                    }}
                    ref={(e) => {
                      imgFile.current = e;
                    }}
                    hidden
                  />
                )}
              />

              <Divider sx={{mt : 4, mb : 4}}/>
          {activeLanguagesHeader.map((lang) => (
            <Box sx={{}} key={lang.value}>
            <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2, ml : 2}}>{lang.name}</Typography>
            <Box style={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.title ? 'Title*' : 'Title'}
              </InputLabel>
              <Controller
                name={`title.${lang.value}`}
                rules={{ required: false }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`${lang.name}`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.title ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.title) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.title ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter title</Typography> : null }
            </Box>

            <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  mt: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
               {errors?.heading1 ? 'Heading 1*' : 'Heading 1'}
              </InputLabel>
              <Controller
                 name={`heading1.${lang.value}`}
                rules={{ required: false }}
                control={control}
                render={({ field }) => (
                  <TextField
                    placeholder={`${lang.name}`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.subtitle ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.subtitle) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.subtitle ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter subtitle</Typography> : null }
            </Box>

            <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  mt: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
               {errors?.description1 ? 'Description 1*' : 'Description 1'}
              </InputLabel>
              <Controller
                 name={`description1.${lang.value}`}
                rules={{ required: false }}
                control={control}
                render={({ field }) => (
                  <TextField
                    placeholder={`${lang.name}`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.subtitle ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.subtitle) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.subtitle ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter subtitle</Typography> : null }
            </Box>

            <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  mt: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
               {errors?.heading2 ? 'Heading 2*' : 'Heading 2'}
              </InputLabel>
              <Controller
                 name={`heading2.${lang.value}`}
                rules={{ required: false }}
                control={control}
                render={({ field }) => (
                  <TextField
                    placeholder={`${lang.name}`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.subtitle ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.subtitle) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.subtitle ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter subtitle</Typography> : null }
            </Box>

            <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}>{errors?.description2 ? 'Description 2*' : 'Description 2'}</InputLabel>
              <Controller
                 name={`description2.${lang.value}`}
                rules={{ required: true }} 
                control={control}
                render={({ field }) => (
                  <ReactQuill
                    style={{ height: "180px" }}
                    modules={modules}
                    maxLength={3000}
                    {...field}
                  />
                )}
              />
            </Box>
            <Box style={{ marginTop : '2rem', marginLeft : '1rem'}}>
            {errors?.description ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter description</Typography> : null}
            </Box>

            <Divider sx={{mt : 2, mb : 2}}/>
            </Box>
          ))}

          {/* <Box sx={{mt : 2, mb: 2, ml : 2}}>
          <Button variant='contained' onClick={() => addHeaderLanguage()}>Add Language</Button>
          </Box> */}

          {/* <Divider sx={{mt : 2, mb : 2}}/> */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              marginTop : 0,
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "black",
                }}>Video Urls</Typography>
            </Box>
          
            {videoFields.map((field, index) => (
  <Box sx={{ml : 2, mr : 2}} key={field.id} display="flex" alignItems="center" gap={1} mt={2}>
    <Controller
      name={`videoUrls.${index}.url`}
      control={control}
      rules={{
        validate: (value) => {
          if (!value) return true;
          const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w-]{11}$/;
          return youtubeRegex.test(value) || "Please enter a valid YouTube URL";
        },
      }}
      render={({ field }) => (
        <TextField
          placeholder="Enter Video URL"
          sx={{
            flexGrow: 1,
            backgroundColor: "rgb(249, 250, 251)",
            "& .MuiInputBase-input": {
              color: errors?.videoUrls?.[index]?.url ? "red" : "black",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: errors?.videoUrls?.[index]?.url ? "red" : "rgba(0, 0, 0, 0.23)",
              },
              "&:hover fieldset": {
                borderColor: errors?.videoUrls?.[index]?.url ? "red" : "rgba(0, 0, 0, 0.23)",
              },
              "&.Mui-focused fieldset": {
                borderColor: errors?.videoUrls?.[index]?.url ? "red" : "rgba(0, 0, 0, 0.23)",
              },
            },
          }}
          error={Boolean(errors?.videoUrls?.[index]?.url)}
          helperText={errors?.videoUrls?.[index]?.url?.message}
          {...field}
        />
      )}
    />
    {videoFields.length > 1 && (
      <IconButton onClick={() => removeVideo(index)} color="error">
        <Remove />
      </IconButton>
    )}
  </Box>
))}

<Button
  onClick={() => addVideo({ url: "" })}
  startIcon={<Add />}
  variant="contained"
  sx={{ mt: 2, ml : 2 }}
>
  Add Video Link
</Button>


      <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              marginTop : 2,
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "black",
                }}>Images</Typography>
            </Box>

            {imageFields.map((field, index) => {
  const imageWatch = watch(`images.${index}`);

  return (
    <Box key={field.id} m={2}>
      {imageWatch ? (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          padding="23px"
          borderRadius="8px"
          sx={{ border: ".5px solid #1A2461" }}
        >
          <Typography variant="body1" sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {imageWatch instanceof File ? (
              <Box
                sx={{ width: "150px", height: "90px" }}
                component="img"
                src={URL.createObjectURL(imageWatch) || `${process.env.REACT_APP_FILE_PATH}${imageWatch?.filename}`}
                alt="Uploaded"
              />
            ) : (
              <Box
                sx={{ width: "150px", height: "90px" }}
                component="img"
                src={`${process.env.REACT_APP_FILE_PATH}${imageWatch?.filename}`}
                alt="Uploaded"
              />
            )}
            {imageWatch?.name || imageWatch?.originalname}
          </Typography>
          <IconButton onClick={() => removeImage(index)} color="error">
            <Remove />
          </IconButton>
        </Stack>
      ) : (
        <Box
          onClick={() => imgFiles.current[index]?.click()}
          sx={{
            border: errors.images?.[index] ? "1px dashed red" : "1px dashed #1A2461",
            height: "200px",
            borderRadius: "8px",
            backgroundColor: "#F9FBFF",
            margin: "20px 17px 17px",
            cursor: "pointer",
          }}
        >
          <Stack direction="column" alignItems="center" justifyContent="center" height="100%">
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{
                height: "100px",
                width: "100px",
                borderRadius: "100px",
                backgroundColor: "#F2F2F2",
              }}
            >
              <UploadFileIcon fill="#1A2461" />
            </Stack>
            <Typography variant="body1" mt={2}>
              Click to upload
            </Typography>
            <Typography variant="body2">Allowed formats - JPEG, PNG</Typography>
            {errors.images?.[index] && (
              <Typography color="error" mt={1}>
                Please select an image
              </Typography>
            )}
          </Stack>
        </Box>
      )}

      <Controller
        name={`images.${index}`}
        control={control}
        rules={{ required: "Image is required" }}
        render={({ field }) => (
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => handleFileChange(e, index)}
            ref={(e) => (imgFiles.current[index] = e)}
          />
        )}
      />
    </Box>
  );
})}

<Button
  onClick={() => addImage(null)}
  startIcon={<Add />}
  variant="contained"
  sx={{ mt: 2, ml : 2 }}
>
  Add More Images
</Button>

          {/* <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  mt: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
               {errors?.heading2 ? 'Video Link*' : 'Video Link'}
              </InputLabel>
              <Controller
                 name={`videoUrl`}
                rules={{ required: false }}
                control={control}
                render={({ field }) => (
                  <TextField
                    placeholder={`Video URL`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.subtitle ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.subtitle ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.subtitle) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.subtitle ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter subtitle</Typography> : null }
            </Box> */}

            
{/* <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              marginTop : 2,
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "black",
                }}>Show Book Now Button</Typography>
            </Box>

            <Box style={{ padding: "0px 17px 17px" }}>
  <InputLabel
    sx={{
      mb: 1,
      mt: 3,
      fontSize: "18px",
      fontWeight: 600,
      color: "black",
    }}
  >
    {errors?.showButton ? 'Enable Book Now Button*' : 'Enable Book Now Button'}
  </InputLabel>

  <Controller
    name="showButton"
    control={control}
    defaultValue={false}
    rules={{ required: false }}
    render={({ field }) => (
      <FormControlLabel
        control={
          <Switch
            {...field}
            checked={field.value}
            onChange={(e) => field.onChange(e.target.checked)}
            color="primary"
          />
        }
        label={field.value ? "On" : "Off"}
      />
    )}
  />

  {errors?.videoToggle && (
    <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
      Please toggle the switch
    </Typography>
  )}
</Box> */}


            <Divider style={{marginTop : '15px'}}/>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0px 17px 13px",
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={{
                  padding: "10px 20px 10px 20px",
                  mt: 2,
                  width: "20%",
                  fontSize: 20,
                  backgroundColor: "rgb(14, 94, 132)",
                  ":hover": { bgcolor: "rgb(14, 94, 132)" },
                }}
              >
                {isEdit ? "Update" :  "Confirm"}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
    </>
  );
}
